module.exports = __webpack_public_path__ + "media/img/vca/bg-howto-2022-458756d9b9a53093d74797e5b98decb3.png";